import React from "react";
import Unity, { UnityContent } from "react-unity-webgl";

const sendToUnity = {
    
    sendPackage() {
      console.log("sending");
      this.unityContent.send("CommCube", "makeCall", 5);    }
}


class UnityLoader extends React.Component {
    constructor(props) {
      super(props);
  
      // Next up create a new Unity Content object to 
      // initialise and define your WebGL build. The 
      // paths are relative from your index file.
  
      this.unityContent = new UnityContent(
        "Build/unityplayer.json",
        "Build/UnityLoader.js"
      );
      sendToUnity.sendPackage = sendToUnity.sendPackage.bind(this);
    }
   
    
    render() {
  
      // Finally render the Unity component and pass 
      // the Unity content through the props.
  
      return (
      <div className="untiy_wrapper" >
        <Unity unityContent={this.unityContent} />
      </div>
      )
    }
  }
  export {UnityLoader, sendToUnity};